var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cover",on:{"click":_vm.close}},[_c('img',{staticClass:"cover_img",attrs:{"src":require("../assets/img/toAddress.png")}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"cover_tet"},[_vm._v("请在第三方浏览器中打开此页面 "),_c('br'),_vm._v(" 继续支付")])
}]

export { render, staticRenderFns }